// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"dh","itemsContainer":"eh"};